<script setup>
import { RouterView } from "vue-router";
import { onMounted, ref, watch } from "vue";
import TutorConfirmDialog from "@/components/TutorConfirmDialog.vue";
import { registerTutorConfirm } from "@/composables/tutorConfirm";

const confirmRef = ref(null);

watch(
  confirmRef,
  (api) => {
    if (api) registerTutorConfirm(api);
  },
  { flush: "sync" }
);

/** Vue2 App.vue created：去掉首屏 Loading，便于 TutorClient 区分「还在加载」和「真白屏」 */
onMounted(() => {
  const loading = document.getElementById("Loading");
  if (loading?.parentNode) loading.parentNode.removeChild(loading);
});
</script>

<template>
  <!-- Mount before RouterView so confirm API is ready before page onMounted -->
  <TutorConfirmDialog ref="confirmRef" />
  <RouterView />
</template>
